module.exports = __webpack_public_path__ + "static/media/bluemedia.23c04690.svg";